module.exports = __webpack_public_path__ + "static/media/alelo.b76cda08.webp";